import queryString from 'qs';

export const getGiveawayListRequest = (queryParams) => {
  const queries = { limit: 10, page: queryParams?.page };

  if (queryParams?.brand?.value) queries['brands.name'] = queryParams?.brand?.value;
  if (queryParams?.giveaway?.status?.value) queries['status'] = queryParams?.giveaway?.status?.value;
  if (queryParams?.giveaway?.promoSearch) queries['search'] = queryParams?.giveaway?.promoSearch;
  if (queryParams?.sort) queries['sort'] = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getGiveawayListRequest;
